

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface FamilyLinkParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface FamilyLink {
    parentRegId:string,
    id?: string;
    groupId?: string;
    mobile: string;
    displayName: string;
    regId: string;
    patientRegistration?: string;
    tenantId:any;
    primaryFlag?:any;
    parameters?: FamilyLinkParameter[];
    links?: any;
}

export abstract class FamilLinkData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<FamilyLink[]>;
  abstract create(url: string,data: FamilyLink[]): Observable<any>;
  abstract update(url: string,data: FamilyLink): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
